import { postEvent, themeParams, useSignal } from "@telegram-apps/sdk-react";
import { useEffect, useMemo } from "react";

function useTheme() {
  const isDark = useSignal(themeParams.isDark);
  const theme = useMemo(() => (isDark ? "dark" : "light"), [isDark]);

  useEffect(() => {
    if (themeParams.mountSync.isAvailable()) {
      themeParams.mountSync();
    }
    if (themeParams.isMounted()) {
      document.body.setAttribute("data-theme", theme);
      postEvent("web_app_set_header_color", {
        color: isDark ? "#19191a" : "#ffffff",
      });
    }
  }, [theme]);

  return theme;
}

export default useTheme;
